export function showAlert(message, duration = 3000) {
  const el = document.getElementById("alert")
  if (!el) return
  el.textContent = message
  el.classList.add("-is-visible")
  setTimeout(() => el.classList.remove("-is-visible"), duration)
}
